const MEASUREBANKTYPES = {
  Fortalezas: 1,
  Necesidades: 2,
  Justificaciones: 3,
};

export default MEASUREBANKTYPES;
